import {getInitialMeta} from "@helpers/HelperInitialPageState";
import SimplyBookModal from "@components/base/Modal/SimplyBookModal/SimplyBookModal";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	formId: 'partners-form',
	blockTitle: 'Бъди наш партньор',
	blockDesc: 'Попълни формата и ще се свържем с теб в рамките на 1 работен ден.',
	blockContent: {
		fields: {
			name: {
				title: 'Три имена',
				value: '',
				placeholder: 'Иван Георгиев Петров',
				required: true,
				component: 'TextBox',
				inputType: 'text'
			},
			email: {
				title: 'Ел. поща',
				value: '',
				placeholder: 'ivan@mydomain.com',
				required: true,
				component: 'TextBox',
				inputType: 'email'
			},
			phone: {
				title: 'Телефон',
				value: '',
				placeholder: '88 888888',
				required: true,
				component: 'Phone',
				inputType: 'tel'
			},
			company: {
				title: 'Име на фирма',
				value: '',
				placeholder: 'СуперХостинг.БГ ЕООД',
				required: false,
				component: 'TextBox',
				inputType: 'text'
			},
			website: {
				title: 'Уебсайт/портфолио',
				value: '',
				placeholder: 'superhosting.bg',
				required: false,
				component: 'TextBox',
				inputType: 'text'
			},
			type: {
				title: 'Как се определяш',
				value: '',
				placeholder: 'избери от списъка',
				required: true,
				component: 'Select',
				options: [],
				optionsSource: 'taskTypeTags' // Runtime options from RequestForm contextData
			},
			contact: {
				title: 'Как да се свържем с теб',
				value: '',
				placeholder: 'избери от списъка',
				required: true,
				component: 'Select',
				options: [
					{value: 'phone', label: 'телефон разговор'},
					{value: 'zoom_meeting', label: 'видео разговор (zoom)'},
				]
			},
			existingClients: {
				title: '',
				label: 'Вече имам клиенти в СуперХостинг.БГ',
				value: false,
				required: false,
				component: 'CheckBox'
			},
			terms: {
				title: '',
				label: 'Съгласен съм с <a href="/web-hosting-page-terms-and-agreements.php" target="_blank" rel="noopener">общите условия</a> за участие в партньорската програма.',
				value: false,
				required: true,
				component: 'CheckBox'
			},
		},
		buttonText: 'Изпрати заявка',
		buttonAction: 'SubmitOperatorTask',
		buttonParams: ['#contextOperatorTask#', 'CreatePartnerTask', '#formData#', '#onSuccess#', '#onError#']
	},
	successText: [
		'Заявката е направена. Наш колега ще се свърже с теб в работни дни от 9:00 до 18:00, за да уточните всички детайли.'
	],
	errorMsg: {
		emptyName: 'Моля, въведи своето име.',
		emptyEmail: 'Моля, увери се, че си въвел своя имейл.',
		invalidEmail: 'Моля, въведи валиден имейл.',
		emptyPhoneCode: 'Моля, увери се, че си избрал код.',
		emptyPhone: 'Моля, увери се, че си попълнил полето за телефон.',
		emptyType: 'Моля, избери как се определяш.',
		emptyContact: 'Моля, избери как да се свържем с теб.',
		emptyTerms: 'Моля, приеми общите условия, за да продължиш.',
	},
	bookingWidget: {
		title: 'Запази час',
		reopenText: 'Резервация',
		Modal: SimplyBookModal, // Modal opened via useDataFileAction
		company: 'superhosting', // Company
		theme: 'space',
		themeSettings: {
			timeline_hide_unavailable: '1',
			sb_base_color: '#fb5c17',
			hide_past_days: '0',
			timeline_show_end_time: '0',
			timeline_modern_display: 'as_slots',
			display_item_mode: 'block',
			body_bg_color: '#ffffff',
			sb_review_image: '',
			dark_font_color: '#474747',
			light_font_color: '#ffffff',
			btn_color_1: '#fb5c17',
			sb_company_label_color: '#000000',
			hide_img_mode: '0',
			show_sidebar: '1',
			sb_busy: '#ffa67d',
			sb_available: '#d6ebff'
		},
		predefined: {
			service: '2',   // Service ID
			provider: '2'  // Provider ID (Panayot)
		},
		timeline: 'modern',
		datepicker: 'top_calendar',
		isRtl: false,
		appConfig: {
			clear_session: 0,
			allow_switch_to_ada: 0
		},
		triggerField: 'contact', // Filed name from form
		triggerValue: 'zoom_meeting' // Open popup only if this value is selected
	},
	noteData: []
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	formId: 'partners-form',
	blockTitle: 'Become our partner',
	blockDesc: 'Fill out the form and we will get in touch with you within 1 business day.',
	blockContent: {
		fields: {
			name: {
				title: 'Full name',

				value: '',

				placeholder: 'Ivan Georgiev Petrov',
				required: true,
				component: 'TextBox',
				inputType: 'text'
			},
			email: {
				title: 'Email',
				value: '',
				placeholder: 'ivan@mydomain.com',
				required: true,
				component: 'TextBox',
				inputType: 'email'
			},
			phone: {
				title: 'Phone',
				value: '',
				placeholder: '88 888888',
				required: true,
				component: 'Phone',
				inputType: 'tel'
			},
			company: {
				title: 'Company name',

				value: '',

				placeholder: 'SuperHosting.BG Ltd.',
				required: false,
				component: 'TextBox',
				inputType: 'text'
			},
			website: {
				title: 'Website/portfolio',
				value: '',
				placeholder: 'superhosting.bg',
				required: false,
				component: 'TextBox',
				inputType: 'text'
			},
			type: {
				title: 'How do you identify yourself',
				value: '',
				placeholder: 'select from the list',
				required: true,
				component: 'Select',
				options: [],
				optionsSource: 'taskTypeTags' // Runtime options from RequestForm contextData
			},
			contact: {
				title: 'How should we contact you',
				value: '',
				placeholder: 'select from the list',
				required: true,
				component: 'Select',
				options: [
					{value: 'phone', label: 'phone call'},
					{value: 'zoom_meeting', label: 'video call (Zoom)'},
				]
			},
			existingClients: {
				title: '',
				label: 'I already have clients with SuperHosting.BG',
				value: false,
				required: false,
				component: 'CheckBox'
			},
			terms: {
				title: '',
				label: 'I agree to the <a href="/web-hosting-page-terms-and-agreements.php" target="_blank" rel="noopener">Terms and Conditions</a> for participating in the Partner Program.',
				value: false,
				required: true,
				component: 'CheckBox'
			},
		},
		buttonText: 'Submit request',
		buttonAction: 'SubmitOperatorTask',
		buttonParams: ['#contextOperatorTask#', 'CreatePartnerTask', '#formData#', '#onSuccess#', '#onError#']
	},
	successText: [
		'Your request has been submitted. A member of our team will contact you on business days between 9:00 AM and 6:00 PM to discuss all the details.'
	],
	errorMsg: {
		emptyName: 'Please enter your name.',
		emptyEmail: 'Please make sure you have entered your email address.',
		invalidEmail: 'Please enter a valid email address.',
		emptyPhoneCode: 'Please make sure you have selected a code.',
		emptyPhone: 'Please make sure you have entered your phone number.',
		emptyType: 'Please select how you identify yourself.',
		emptyContact: 'Please select how you would like us to contact you.',
		emptyTerms: 'Please accept the Terms and Conditions to continue.',
	},
	bookingWidget: {
		title: 'Book an appointment',
		reopenText: 'Booking',
		Modal: SimplyBookModal, // Modal opened via useDataFileAction
		company: 'superhosting', // Company
		theme: 'space',
		themeSettings: {
			timeline_hide_unavailable: '1',
			sb_base_color: '#fb5c17',
			hide_past_days: '0',
			timeline_show_end_time: '0',
			timeline_modern_display: 'as_slots',
			display_item_mode: 'block',
			body_bg_color: '#ffffff',
			sb_review_image: '',
			dark_font_color: '#474747',
			light_font_color: '#ffffff',
			btn_color_1: '#fb5c17',
			sb_company_label_color: '#000000',
			hide_img_mode: '0',
			show_sidebar: '1',
			sb_busy: '#ffa67d',
			sb_available: '#d6ebff'
		},
		predefined: {
			service: '2',   // Service ID
			provider: '2'  // Provider ID (Panayot)
		},
		timeline: 'modern',
		datepicker: 'top_calendar',
		isRtl: false,
		appConfig: {
			clear_session: 0,
			allow_switch_to_ada: 0
		},
		triggerField: 'contact', // Filed name from form
		triggerValue: 'zoom_meeting' // Open popup only if this value is selected
	},
	noteData: []
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];
